import { render, staticRenderFns } from "./SelectContactField.vue?vue&type=template&id=f3873a8c"
import script from "./SelectContactField.vue?vue&type=script&lang=js"
export * from "./SelectContactField.vue?vue&type=script&lang=js"
import style0 from "./SelectContactField.vue?vue&type=style&index=0&id=f3873a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports